module.exports = __webpack_public_path__ + "img/mkz20.783a5a0a.png";